import { zeroPadding } from './zeroPadding'

export const calcDeepRGB = (colorCode: string) => {
  const r = parseInt(colorCode.substring(1, 3), 16)
  const g = parseInt(colorCode.substring(3, 5), 16)
  const b = parseInt(colorCode.substring(5, 7), 16)

  const R = zeroPadding(Math.floor((r * 80) / 100).toString(16))
  const G = zeroPadding(Math.floor((g * 80) / 100).toString(16))
  const B = zeroPadding(Math.floor((b * 80) / 100).toString(16))

  return `#${R}${G}${B}`
}
